import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const EmbeddedScorecardFormSubscribe = ({ onSuccess, onError }) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitSubscribeForm = async (e) => {
    e.preventDefault();

    const dataToSend = {
      ...formData,
      scorecardForm: true,
    };

    try {
      const response = await axios.post(
        `${baseURL}/api/submit-subscribe-form`,
        dataToSend,
        {
          withCredentials: "true",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setFormData({ firstName: "", lastName: "", email: "", zipCode: "" });
        onSuccess("subscribe");
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <form onSubmit={handleSubmitSubscribeForm}>
      <div className="form-group" id="subscribe">
        <label for="firstName">* First Name</label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          onChange={handleChange}
          value={formData.firstName}
          required
        />
      </div>
      <div className="form-group">
        <label for="lastName">* Last Name</label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          onChange={handleChange}
          value={formData.lastName}
          required
        />
      </div>
      <div className="form-group">
        <label for="email">* Email</label>
        <input
          type="email"
          id="email"
          name="email"
          onChange={handleChange}
          value={formData.email}
          required
        />
      </div>
      <div className="form-group">
        <label for="zipCode">* Zip/Postal Code</label>
        <input
          type="text"
          id="zipCode"
          name="zipCode"
          onChange={handleChange}
          value={formData.zipCode}
          required
          minLength={4}
        />
      </div>
      <div className="submit-policy">
        <PolicyContainer text="Subscribe" />
        <Button text="Subscribe" color="var(--cornflower-blue)"></Button>
      </div>
    </form>
  );
};

export default EmbeddedScorecardFormSubscribe;
